import type { FormWarning } from '../dtos'

/**
 * Retrieves all warnings that match the current form value.
 * @param {object} formValue - The form value to compare against the warnings.
 * @param {FormWarning[]} warnings - The warnings to filter.
 * @returns {FormWarning[]} - The warnings that match the current form value.
 */
export function getFormWarnings(formValue: any, warnings?: FormWarning[]): FormWarning[] {
    return warnings?.filter((warning) => {
        const value = getValueByPath(formValue, warning.path)
        return warning.value === value
    }) ?? []
}

/**
 * Retrieves a nested property value from an object based on a dot-separated path.
 * @param {object} obj - The object to traverse.
 * @param {string} path - The dot-separated path, e.g. "property.anotherProperty".
 * @returns {*} - The value at the given path or undefined if the path is invalid.
 */
export function getValueByPath(obj: any, path: string): any {
    return path.split('.').reduce((current, key) => {
        return current ? current[key] : undefined
    }, obj)
}
